/* eslint-disable react/no-unescaped-entities */
import LegalPageLayout from './LegalPageLayout';

/**
 * Mentions légales — production-ready, conforms to French law for a SaaS
 * publisher (LCEN articles 6-III-1 a/b/c, code de la consommation art.
 * L. 111-1 et s.). All identifying values are grouped at the top of the
 * file so they can be edited without touching the JSX.
 *
 * Edit-friendly publisher block ↓
 */
const PUBLISHER = {
  legalName: 'HÉRITA',
  email: 'helloherita@proton.me',
};

const HOST = {
  name: 'Kubernetes / Cloud Provider — Emergent Platform',
  legalForm: 'Service d\'hébergement managé',
  contact: 'helloherita@proton.me',
};

const MentionsLegales = () => {
  return (
    <LegalPageLayout
      eyebrow="Mentions légales"
      title="Informations légales relatives à Hérita."
      lastUpdated="1ᵉʳ juin 2026"
      testId="page-mentions-legales"
      seoTitle="Mentions légales | HÉRITA"
      seoDescription="Mentions légales du service Hérita : éditeur, hébergement, propriété intellectuelle, médiation et coordonnées de l'analyse de documents notariés."
      seoPath="/mentions-legales"
    >
      <p>
        Conformément aux dispositions des articles 6-III et 19 de la loi n° 2004-575
        du 21 juin 2004 pour la confiance dans l'économie numérique (LCEN), il est
        précisé aux utilisateurs du service Hérita l'identité des différents
        intervenants dans le cadre de sa réalisation et de son suivi.
      </p>

      <h2>Éditeur du site</h2>
      <p>
        Le site et le service « Hérita » (ci-après le « Service ») sont édités par :
      </p>
      <ul>
        <li><strong>Dénomination :</strong> {PUBLISHER.legalName}</li>
        <li>
          <strong>Contact :</strong>{' '}
          <a href={`mailto:${PUBLISHER.email}`}>{PUBLISHER.email}</a>
        </li>
      </ul>

      <h2>Directeur de la publication</h2>
      <p>
        Le responsable de la publication du site HÉRITA peut être contacté à
        l'adresse suivante :{' '}
        <a href={`mailto:${PUBLISHER.email}`}>{PUBLISHER.email}</a>.
      </p>

      <h2>Hébergeur</h2>
      <p>
        Le Service est hébergé sur une infrastructure managée par :
      </p>
      <ul>
        <li><strong>Nom :</strong> {HOST.name}</li>
        <li><strong>Activité :</strong> {HOST.legalForm}</li>
        <li>
          <strong>Contact :</strong>{' '}
          <a href={`mailto:${HOST.contact}`}>{HOST.contact}</a>
        </li>
      </ul>

      <h2>Propriété intellectuelle</h2>
      <p>
        L'ensemble des éléments accessibles sur le Service — y compris notamment
        les textes, illustrations, photographies, graphismes, logos, marques,
        bases de données, modèles d'analyse, prompts, code source, architecture
        logicielle et identité visuelle — sont la propriété exclusive d'Hérita ou
        font l'objet d'une autorisation d'utilisation.
      </p>
      <p>
        Toute représentation, reproduction, modification, adaptation, diffusion
        ou exploitation, totale ou partielle, des éléments du Service, par quelque
        procédé que ce soit, sans l'autorisation écrite préalable d'Hérita, est
        strictement interdite et constituerait une contrefaçon sanctionnée par
        les articles L.335-2 et suivants du Code de la propriété intellectuelle.
      </p>
      <p>
        Les documents transmis par les utilisateurs (actes notariés, déclarations
        de succession, etc.) demeurent leur propriété exclusive. Hérita ne
        revendique aucun droit sur ces documents et les utilise uniquement aux
        fins décrites dans la{' '}
        <a href="/confidentialite">politique de confidentialité</a>.
      </p>

      <h2>Marque</h2>
      <p>
        « Hérita » est une marque utilisée par l'éditeur pour identifier son
        Service. Toute reproduction, imitation ou utilisation, totale ou
        partielle, du signe « Hérita » sans autorisation préalable est
        prohibée.
      </p>

      <h2>Liens hypertextes</h2>
      <p>
        Le Service peut contenir des liens hypertextes pointant vers des sites
        tiers (par exemple : sites institutionnels, sources documentaires
        publiques). Hérita n'exerce aucun contrôle sur ces sites et décline
        toute responsabilité quant à leur contenu, leur disponibilité ou les
        traitements qui pourraient y être réalisés.
      </p>

      <h2>Limitation de responsabilité éditoriale</h2>
      <p>
        Les analyses produites par Hérita sont fournies à titre strictement
        informatif. Elles ne constituent ni un conseil juridique, ni un conseil
        fiscal, ni un conseil notarial personnalisé. Elles ne remplacent en aucun
        cas l'avis d'un notaire ou d'un professionnel du droit dûment habilité.
        Pour toute décision patrimoniale, l'utilisateur est invité à consulter
        son notaire ou son conseil.
      </p>

      <h2>Droit applicable et juridiction compétente</h2>
      <p>
        Les présentes mentions légales sont régies par le droit français. En cas
        de litige, et après échec d'une tentative de résolution amiable adressée
        par écrit à <a href={`mailto:${PUBLISHER.email}`}>{PUBLISHER.email}</a>,
        les tribunaux français seront seuls compétents.
      </p>

      <h2>Pour aller plus loin</h2>
      <p>
        Consultez également notre{' '}
        <a href="/confidentialite">politique de confidentialité</a>, nos{' '}
        <a href="/cgu">conditions générales d'utilisation</a>, ou contactez-nous
        via la <a href="/contact">page Contact</a>.
      </p>
    </LegalPageLayout>
  );
};

export default MentionsLegales;
